<template>
  <q-card flat :style="$q.screen.lt.md?'':'min-width: 500px'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>نوع چاپ را انتخاب کنید</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-select v-model="selectedPrintForm"
                :options="printList"
                option-value="id"
                option-label="Caption"
                filled
                label="نوع گزارش خود را انتخاب کنید"
      />
    </q-card-section>
    <q-card-actions align="left">
      <q-btn label="تایید" @click="loadReport" icon="done" color="primary"/>
      <q-btn label="انصراف" v-close-popup icon="cancel" color="red" flat class="q-ml-sm"/>
    </q-card-actions>
  </q-card>
</template>

<script>
export default {
  name: 'FactorPrintDialog',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
      default: () => 'گزارش'
    },
    factorInfo: {
      type: Object,
      default: () => {
      }
    },
    customerCode: {
      type: Number,
      default: () => undefined
    }
  },
  data() {
    return {
      selectedPrintForm: undefined,
      printList: [
        {id: 1, Caption: 'چاپ فاکتور به همراه سربرگ', CompanyHeader: true},
        {id: 2, Caption: 'چاپ فاکتور بدون سربرگ', CompanyHeader: false},
        {id: 3, Caption: 'چاپ فاکتور بدون سربرگ به همراه تعهدات و ره گیری', CompanyHeader: false},
        {id: 4, Caption: 'چاپ فاکتور بدون سربرگ به همراه تعهدات و ره گیری', CompanyHeader: false}
      ]
    }
  },
  methods: {
    async loadReport() {
      if (this.selectedPrintForm) {
        await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/فاکتورهای فروش/${(this.selectedPrintForm.id===1 || this.selectedPrintForm.id===2?'فاکتور فروش':'فاکتور فروش به همراه تاییدیه ها')}?rs:Format=PDF&SaleNum=${this.factorInfo.Sale_Num}&SaleKind=${this.factorInfo.Sale_Kind}&CustomerCode=${this.factorInfo.Cs_Code}&CompanyHeader=${this.selectedPrintForm.CompanyHeader}&rc:Parameters=False&rc:Zoom=Page Width`)
      } else {
        this.$q.notify(
            {
              type: 'negative',
              color: 'negative',
              position: 'top',
              message: 'نوع گزارش را انتخاب نمایید'
            })
      }
    }
  }
}
</script>